import { Component } from '@angular/core';
import { finalize } from 'rxjs';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ParticipationPortalService } from '../../services/participation-portal.service';

@Component({
  selector: 'app-opportunity-dialog',
  templateUrl: './opportunity-dialog.component.html',
})
export class OpportunityDialogComponent {
  isJoining = false;
  requestSent = false;

  constructor(
    private ref: DynamicDialogRef,
    private participationPortalService: ParticipationPortalService
  ) {}

  join() {
    this.isJoining = true;
    this.participationPortalService.requestAccess().pipe(
      finalize(() => {
        this.isJoining = false;
      })
    ).subscribe({
      next: () => {
        this.requestSent = true;
      }
    });
  }

  done() {
    this.ref.close();
  }

  view() {
    window.open('https://participations.equalseat.com', '_blank');
    this.ref.close();
  }

  close() {
    this.ref.close();
  }
}
